module.exports = __webpack_public_path__ + "img/badge-vo-fill.9f69f7f5.svg";